module.exports = __webpack_public_path__ + "static/media/1_N55RJiGdQ5WxjQHGUk26mQ.747637fe.png";